export const faqItems = [
  {
    question: '¿Cuánto dura el esmaltado permanente?',
    answer: 'Entre 15 y 21 días aproximadamente.',
  },
  {
    question: '¿Cuánto dura Soft Gel?',
    answer: 'Entre 21 y 30 días aproximadamente.',
  },
  {
    question: '¿Pueden retirar trabajo realizado en otro centro?',
    answer: 'Sí, con costo adicional según el producto.',
  },
  { question: '¿Atienden menores de edad?', answer: 'Sí.' },
  { question: '¿Puedo asistir acompañada?', answer: 'No.' },
  { question: '¿Es necesario reservar?', answer: 'Sí.' },
  {
    question: '¿Atienden sin reserva?',
    answer: 'Solamente dependiendo de la disponibilidad.',
  },
  { question: '¿Hay estacionamiento?', answer: 'Sí.' },
  {
    question: '¿Realizan diseños personalizados?',
    answer: 'Sí, recreando ideas y diseños, pero no retratos.',
  },
  {
    question: '¿Puedo enviar previamente el diseño que quiero?',
    answer: 'Sí, preferiblemente. Puedes enviarlo al abrir la conversación por WhatsApp.',
  },
];
